import $ from 'jquery';
import 'slick-carousel';


function bestSellValggs() {

    var BestSellActiveSelect = "#neo-bestsellers-slider .slick-slide.slick-active";
    var BestSellTotal = ($('#neo-bestsellers-slider .slick-slide').length);

    if ($(BestSellActiveSelect).length == 3) {
        var BestSellActive = 3;
        if ($(BestSellActiveSelect + '.slide-1').length) {
            var BestSellPage = 1;

        } else if ($(BestSellActiveSelect + '.slide-4').length) {
            var BestSellPage = 2;

        } else if ($(BestSellActiveSelect + '.slide-7').length) {
            var BestSellPage = 3;
        }
    } else if ($(BestSellActiveSelect).length == 2) {
        var BestSellActive = 2;
        if ($(BestSellActiveSelect + '.slide-1').length) {
            var BestSellPage = 1;

        } else if ($(BestSellActiveSelect + '.slide-3').length) {
            var BestSellPage = 2;

        } else if ($(BestSellActiveSelect + '.slide-5').length) {
            var BestSellPage = 3;
        } else if ($(BestSellActiveSelect + '.slide-7').length) {
            var BestSellPage = 4;
        }

    } else if ($(BestSellActiveSelect).length == 1) {
        var BestSellActive = 1;
        if ($(BestSellActiveSelect + '.slide-1').length) {
            var BestSellPage = 1;

        } else if ($(BestSellActiveSelect + '.slide-2').length) {
            var BestSellPage = 2;

        } else if ($(BestSellActiveSelect + '.slide-3').length) {
            var BestSellPage = 3;
        } else if ($(BestSellActiveSelect + '.slide-4').length) {
            var BestSellPage = 4;
        } else if ($(BestSellActiveSelect + '.slide-5').length) {
            var BestSellPage = 5;
        } else if ($(BestSellActiveSelect + '.slide-6').length) {
            var BestSellPage = 6;
        } else if ($(BestSellActiveSelect + '.slide-7').length) {
            var BestSellPage = 7;
        } else if ($(BestSellActiveSelect + 'slide-8').length) {
            var BestSellPage = 8;
        }
    }

    var numofPages = Math.ceil(parseInt(BestSellTotal, 10) / parseInt(BestSellActive, 10));

    console.log("numofPages: " + numofPages);

    $(".neo-bestsellers-pagination span.current").text(BestSellPage);
    $(".neo-bestsellers-pagination span.total").text(numofPages);

}

$(document).ready(function () {
    $('#neo-bestsellers-slider').slick({
        prevArrow: '<span class="slick-arrow slick-previous"></span>',
        nextArrow: '<span class="slick-arrow slick-next"></span>',
        infinite: false,
        lazyLoad: 'ondemand',
        dots: true,
        slidesToShow: 3,
        slidesToScroll: 3,
        afterChange: bestSellValggs(),
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
        ]
    });

    $('#neo-bestsellers-slider').on('afterChange', function (event, slick, currentSlide) {
        bestSellValggs()
    });

    $('#neo-bestsellers-slider').on('init', function (event, slick) {
        bestSellValggs()
    });

    $(window).bind('resize', function () {
        bestSellValggs();
    }).trigger('resize');

    // bestseller hover magic
    $('.neo-bestseller-product').hover(
        function () {
            $(this).closest('.neo-bestseller-product').toggleClass('hover');
        }
    );

    $('.neo-bestseller-product form, .neo-bestseller-product .form-holder').hover(
        function () {
            $(this).closest('.neo-bestseller-product').toggleClass('hover');
        }
    );

    // bestseller image variant switch
    $(function () {
        $("select.single-option-selector").on('change', function () {
            var newIMG = $(this).find("option:selected").attr('data-image');
            $(this).closest('.slick-slide').find('.neo-bestseller-img-container img').attr("src", newIMG);
            $(this).closest('.slick-slide').find('.neo-bestseller-img-container img').attr("srcset", newIMG);
        });
    });
});
